export { default } from './RecognitionStar'
